import { combineReducers } from "@reduxjs/toolkit";
import authenticationSlice from "./authenticationSlice";
import authSlice from './authSlice';
import categoriesSlice from './categoriesSlice';
import getRoleSlice from './getRoleSlice';
import foodSlice from './foodSlice';
import userSlice from './userSlice';
import customerSlice from './CustomerSlice';
import agentSlice from './agentSlice';
import orderSlice from './orderSlice';
import agentLookUpSlice from './agentLookUpSlice';
import transactionSlice from "./transactionSlice";
import notificationSlice from "./notificationSlice";
import overviewSlice from "./overviewSlice";
import reviewSlice from "./reviewSlice";
import complaintSlice from "./complaintSlice";


const combinedSlices = combineReducers({
  auth: authSlice,
  signIn: authenticationSlice,
  category: categoriesSlice,
  food: foodSlice,
  roles: getRoleSlice,
  user: userSlice,
  customer: customerSlice,
  agent: agentSlice,
  order: orderSlice,
  agentList: agentLookUpSlice,
  transaction: transactionSlice,
  notification: notificationSlice,
  overview: overviewSlice,
  review: reviewSlice,
  complaint: complaintSlice,
})

export default combinedSlices;